// Cookie cache.
let cache = null;
const getCache = function () {
  if (cache === null) {
    cache = Object.fromEntries(document.cookie.split(/; */).map(c => {
      const [key, ...v] = c.split('=');
      return [key, decodeURIComponent(v.join('='))];
    }));
  }
  return cache;
};
export const cookies = {
  // Global cookie management.

  getAll: getCache,
  flushCache: () => {
    // Allow the cache to be emptied since another code might, but hopefully won't, have manipulated the cookie outside of this solution.
    cache = null;
  },
  // Individual cookie management.

  delete: name => {
    // Set cookie in document as expired.
    document.cookie = name + '=; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Path=/; SameSite=Strict;';

    // Delete from cache as well.
    if (cache !== null) {
      // Ensure cache exists.
      delete cache[name.trim()];
    }
  },
  has: name => {
    // Check if property exists on cache.
    return Object.prototype.hasOwnProperty.call(getCache(), name.trim());
  },
  get: name => {
    name = name.trim();
    const _cache = getCache();
    if (Object.prototype.hasOwnProperty.call(_cache, name)) {
      return _cache[name];
    }
    return undefined;
  },
  set: (name, value = '', days = 60, sameSite = null) => {
    name = name.trim();

    // Set cookie in document.
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    let sameSiteOption = null;
    if (!sameSite || sameSite === 'strict') {
      sameSiteOption = 'Strict'; // First party access only.
    } else if (sameSite === 'lax') {
      sameSiteOption = 'Lax';
    } else if (sameSite === 'none') {
      sameSiteOption = 'None; Secure'; // Third party access.
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; Path=/; SameSite=' + sameSiteOption + ';';

    // Ensure cache exists.
    getCache();
    // Set in cache as well.
    cache[name] = value;
  }
};
export default cookies;